import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";

const AdvantageSection = () => {
  return (
    <div className="px-8 py-12 md:p-12 lg:p-24">
      <div className="grid grid-cols-12 max-w-[1440px] mx-auto md:gap-x-10 lg:gap-x-16 xl:gap-x-24">
        <div className="col-span-12 md:col-span-6 flex flex-col justify-center items-end gap-y-4">
          <div className="flex flex-col gap-y-4 text-left w-full">
            <TextGradient overrideClassName="mobile-h2 md:h3 lg:h2 py-2">
              Take advantage of your options.
            </TextGradient>
            <span className="text-body-xl text-text-color-mid-em">
              Attention to detail, by design. A careful review of your business
              is our promise. Let’s explore what we can do together.
            </span>
          </div>
        </div>
        <div className="col-span-12 md:col-span-6 flex items-center justify-center">
          <div className="w-4/5 pt-10 md:pt-0 md:w-full">
            <Image
              className="rounded-lg"
              src="/images/acquisitions/advantage-section.png"
              alt="Advantages"
              width={560}
              height={640}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvantageSection;
